import { PrivateInterceptor } from '../../Base/interceptors/PrivateInterceptor'

export const getAranceles = async () =>{
    const result = await PrivateInterceptor(`IMEX/getAranceles`, 'GET');
    return result;
}

export const getArancelesPorID = (IdArancel) => {
    const respuesta = PrivateInterceptor("IMEX/getArancelesPorID", "POST", {IdArancel});
    return respuesta;
};

export const GuardarArancel = (Datos) => {
    const respuesta = PrivateInterceptor("IMEX/GuardarArancel", "POST", {Datos});
    return respuesta;
};

export const EditarArancel = (Datos) => {
    const respuesta = PrivateInterceptor("IMEX/EditarArancel", "POST", {Datos});
    return respuesta;
};

export const chageEstadoAranceles = async (data) => {
  const result = await PrivateInterceptor(`IMEX/chageEstadoAranceles`, 'POST', data);
  return result;
};